import { render, staticRenderFns } from "./StudentComments.vue?vue&type=template&id=7003364a&scoped=true&"
import script from "./StudentComments.vue?vue&type=script&lang=js&"
export * from "./StudentComments.vue?vue&type=script&lang=js&"
import style0 from "./StudentComments.vue?vue&type=style&index=0&id=7003364a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7003364a",
  null
  
)

export default component.exports